function extractDate(value) {
  let date = value?.trim()?.replace(/\s+/g,' ')
  if (date?.includes(' ')) date = date.split(' ')[0]
  if (date?.includes('T')) date = date.split('T')[0]
  if (!date) return null

  let d, m, y

  if (date.match(/^\d{4}/)) [y,m,d] = date.split(/[/.-]/)
  if (date.match(/\d{4}$/)) [d,m,y] = date.split(/[/.-]/)

  if (!d || !m || !y) return null
  d = d?.padStart(2,'0')
  m = m?.padStart(2,'0')
  const dateString = `${y}-${m}-${d}`

  if (!dateString.match(/^\d{4}-\d{2}-\d{2}$/)) return null
  if (isNaN(new Date(dateString).getTime())) return null

  return dateString
}

function extractTime(value) {
  let time = value?.trim()?.replace(/\s+/g,' ')
  if (time?.includes(' ')) time = time.split(' ')[1]
  if (time?.includes('T')) time = time.split('T')[1]
  if (time?.includes('.')) time = time.split('.')[0]

  if (!time) return null
  if (!time.match(/^\d{1,2}:\d{2}(:\d{2})?$/)) return null

  let [ h, m, s ] = time.split(':')
  h = h?.padStart(2,'0')
  s = s || '00'
  const timeString = `${h}:${m}:${s}`

  if (!timeString.match(/^\d{2}:\d{2}:\d{2}$/)) return null
  if (isNaN(new Date().setHours(h,m,s))) return null

  return timeString
}

export function getDate (value) {
  const date = extractDate(value)
  if (!date) return null
  const [y,m,d] = date.split('-')
  return `${d}/${m}/${y}`
}

export function getDateTime (value, lenient = false) {
  const date = getDate(value)
  const time = extractTime(value)
  if (!date) return null
  if (!time && !lenient) return null
  return `${date} ${time || '00:00:00'}`
}

export function getISODate (value) {
  return extractDate(value)
}

export function getISODateTime (value, lenient = false) {
  const date = getISODate(value)
  const time = extractTime(value)
  if (!date) return null
  if (!time && !lenient) return null
  return `${date} ${time || '00:00:00'}`
}

export function getTime (value, lenient = false) {
  const time = extractTime(value)
  return lenient ? (time || '00:00:00') : time
}

export function isValidDate(value) {
  if (!value) return true
  return !!getDate(value)
}

export function isValidDateTime(value, lenient = false) {
  if (!value) return true
  const x = getDateTime(value, lenient)
  return !!getDateTime(value, lenient)
}

export function isValidTime(value, lenient = false) {
  if (!value) return true
  return !!getTime(value, lenient)
}